//core
import React, {useState, useEffect, FC} from 'react';
//components
import {Item} from './Item';
//utils
import moment from 'moment';
import utils from 'utils';
//effects
import useAuthAlert from 'effects/useAuthAlert';
import {useSelector} from 'react-redux';
import IStoreState from 'store/types';
import {ModalHandlerProps} from '.';
import {IPublicEvent} from 'types/publicEvent';

interface IProps {
  date: string;
  eventIdProcessing?: string;
  onModalHandler: (props: ModalHandlerProps) => void;
}

export const PublicSchedule: FC<IProps> = ({date, eventIdProcessing, onModalHandler}: IProps) => {
  const events = useSelector((state: IStoreState) => state.publicEvents.list);

  const [days, setDays] = useState<string[]>([]);

  useAuthAlert(events.length > 0 && days.length > 0);

  useEffect(() => {
    setDays([date, moment(date).add(1, 'd').format('YYYY-MM-DD'), moment(date).add(2, 'd').format('YYYY-MM-DD')]);
  }, [date]);

  const slots = utils.getCalendarSlots(events, days);

  return (
    <div className="calendar">
      <div className="wrap">
        <div className="column time">
          <div className="cell"></div>
          {slots.map((time) => (
            <div key={time} className="cell">
              {utils.numberToDayTime(time)}
            </div>
          ))}
        </div>
        {days.map((d, index) => {
          const dayEvents = utils.organiseDayEventsByColumns(events.filter((e) => e.date === d));

          return (
            <div key={d} className="column">
              <div
                className={`cell ${moment(date).format('YYYY-MM-DD') === d ? 'today' : ''} ${
                  index % 2 ? 'even' : 'odd'
                }`}>
                <span className="d-block d-sm-none">{moment(d).format('ddd, Do MMM')}</span>
                <span className="d-none d-sm-block">{moment(d).format('dddd, Do MMMM')}</span>
              </div>
              {Array.from(Array(slots.length)).map((v, i) => (
                <div key={i} className="shadow-cell"></div>
              ))}
              {dayEvents.map((e) => (
                <Item
                  key={e.event.id}
                  calendarEvent={e as IPublicEvent}
                  calendarStartTime={slots[0]}
                  onModalHandler={onModalHandler}
                  isEventProcessing={e.event.id === eventIdProcessing}
                />
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};
